
 import * as React from 'react';
 import {createComponent} from '@lit/react';
 
 import {ObiLightSnow as ObiLightSnowElement} from '@oicl/openbridge-webcomponents/dist/icons/icon-light-snow.js';
 
 
 

 
 export const ObiLightSnow = createComponent({
   react: React,
   tagName: 'obi-light-snow',
   elementClass: ObiLightSnowElement,
   events: {
     
   }
  });
 
 